// extracted by mini-css-extract-plugin
export default {"base":"FluGeo_base__SZ41T"};